enum SignatureType {
  InitialHereTabs = 'InitialHereTabs',
  DateTabs = 'DateTabs',
  FullNameTabs = 'FullNameTabs',
  SignHereTabs = 'SignHereTabs',
}
export default SignatureType;
export type VerifyProductType = Utils.VerifyExtends<Model.Enum.SignatureType, Utils.ValueOf<typeof SignatureType>>;
